import { render, staticRenderFns } from "./ListCards.vue?vue&type=template&id=21ee4f36&"
import script from "./ListCards.vue?vue&type=script&lang=js&"
export * from "./ListCards.vue?vue&type=script&lang=js&"
import style0 from "./ListCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports